import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Drawer, Dropdown } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import { Badge } from "antd";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  DropdownContainer,
  DropdownItem,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const history = useHistory();

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };

    const handleMenuClick = (url: string) => {
      window.open(url, "_blank");
    };

    const dropdownItems = [
      {
        key: 'sucursal',
        label: (
          <DropdownItem onClick={() => handleMenuClick("https://ejecomercial.co/pages/login.html")}>
            Sucursal Virtual <Badge color="yellow" text="Antiguo" />
          </DropdownItem>
        ),
      },
      {
        key: 'administrativo',
        label: (
          // agregar badge new 
          <DropdownItem onClick={() => handleMenuClick("https://app.ejecomercial.co")}>
            Administrativo <Badge color="blue" text="Nuevo" />
          </DropdownItem>
        ),
      },
      {
        key: 'inversionistas',
        label: (
          <DropdownItem onClick={() => handleMenuClick("https://investors.ejecomercial.co")}>
            Inversionistas <Badge color="blue" text="Nuevo" />
          </DropdownItem>
          // <DropdownItem >
          //   Inversionistas <Badge color="yellow" text="En desarrollo" />
          // </DropdownItem>
        ),
      },
      {
        key: 'clientes',
        label: (
          <DropdownItem onClick={() => handleMenuClick("https://clients.ejecomercial.co")}>
            Clientes <Badge color="blue" text="Nuevo" />
          </DropdownItem>
          //   <DropdownItem >
          //   Clientes <Badge color="yellow" text="En desarrollo" />
          // </DropdownItem>
        ),
      },
    ];

    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{t("About")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
          <Span>{t("Mission")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => history.push("/blog")}>
          <Span>Blog</Span>
        </CustomNavLinkSmall>
        {/* <CustomNavLinkSmall onClick={() => scrollTo("product")}>
          <Span>{t("Product")}</Span>
        </CustomNavLinkSmall> */}
        <CustomNavLinkSmall style={{ width: "180px" }}>
          <DropdownContainer>
            <Dropdown
              menu={{ items: dropdownItems }}
              placement="bottomRight"
              trigger={['click']}
            >
              <Span>
                <Button>{t("Ingresa")}</Button>
              </Span>
            </Dropdown>
          </DropdownContainer>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage" className="align-items-center">
            <SvgIcon src="logo1.png" width="81" height="51" />
            <SvgIcon src="Tipografía.png" height="35" width="133" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
